import React from 'react';
import PropTypes from 'prop-types';
import { contentExists, contentIsNullOrEmpty, setHeadingLevel } from '../utils/ug-utils.js';
import NavTabs from '../components/navTabs';
import NavTabHeading from '../components/navTabHeading';
import NavTabContent from '../components/navTabContent';
import '../styles/list.css';

function renderTabInfo (pageData) {
	let activeValue = true;
	let activeTabExists = false;
	let checkIfContentAvailable = false;
	let navTabHeadings = [];
	let navTabContent = [];
	

	if (!contentIsNullOrEmpty(pageData) ) {

		let tabID = "";
		activeTabExists = true;
		checkIfContentAvailable = true;

		for (let i = 0; i < pageData.relationships.field_tabs.length; i++) {
			tabID = "pills-" + i;

			if (i > 0) activeValue = false;

		navTabHeadings.push(<NavTabHeading key={`navTabHeading-` + i}
			   active={activeValue}
	   		   heading={pageData.relationships.field_tabs[i].field_tab_title}
	   		   controls={tabID}
				/>);

		navTabContent.push(<NavTabContent key={`navTabContent-` + i}
				  active={activeValue}
				  id={tabID}
				  content=<div dangerouslySetInnerHTML={{ __html: pageData.relationships.field_tabs[i].field_tab_body.processed }} />
				/>);
		}
	}

	if (checkIfContentAvailable === true) {
		return <React.Fragment>
			<NavTabs headings={
				navTabHeadings.map((heading) => {
					return heading;
					})
				}>
				{navTabContent.map((content) => {
					return content;

				})}
			</NavTabs>
			</React.Fragment>
	}

	return null;
}

function pageTabs (props) {


	if(contentExists(props.pageData) && props.pageData.length !== 0){
	   return (<div className="col-md-12 content-area">
		 {renderTabInfo(props.pageData)}
                   </div>
            )

	} else {
		return null;
	}
}

pageTabs.propTypes = {
    pageData: PropTypes.object,
}

pageTabs.defaultProps = {
    pageData: ``,
}

export default pageTabs
